import PropTypes from 'prop-types'
import useSWR from 'swr'
import Button from 'components/common/button'
import Loader from 'components/loader'
import { REFERRAL_LOCIZE } from 'components/referral/landing/const'
import { BUTTON_TYPES } from 'constants/button'
import Typo from 'constants/typography'
import { requestWithCache } from 'lib/api'
import { ENDPOINTS } from 'lib/api/const'
import { withI18next } from 'lib/i18n/withI18next'
import { hasLocizeTranslation } from 'lib/utils/locize'
import styles from './styles.scss'

const ReferralCashBack = ({ t }) => {
  const { data, error } = useSWR(ENDPOINTS.storeCredit.link, requestWithCache, {
    dedupingInterval: ENDPOINTS.storeCredit.cache,
  })

  const cashbackText =
    data?.referral_credit_formatted && !error
      ? data.referral_credit_formatted
      : hasLocizeTranslation(
          t,
          REFERRAL_LOCIZE.REFERRAL_CASHBACK_ZERO_BALANCE.key,
          REFERRAL_LOCIZE.REFERRAL_CASHBACK_ZERO_BALANCE.text,
        )

  if (!data) {
    return (
      <div className="loader-container">
        <Loader />
      </div>
    )
  }
  return (
    <div className="referral-cash-back__container">
      <style jsx>{styles}</style>
      <div className="referral-cash-back__content">
        <span className={Typo.title3}>
          {hasLocizeTranslation(
            t,
            REFERRAL_LOCIZE.REFERRAL_CASHBACK_TITLE.key,
            REFERRAL_LOCIZE.REFERRAL_CASHBACK_TITLE.text,
          )}
        </span>
        <span className={Typo.title2}>{cashbackText}</span>
        <span className={Typo.body2}>
          {hasLocizeTranslation(
            t,
            'REFERRAL_CASHBACK_SUB_TITLE',
            'You will get the cashback rewards when your friends make a first purchase.',
          )}
        </span>
        <Button
          className="referral-cash-back__credit-cta"
          type={BUTTON_TYPES.link}
          link
          aProps={{
            href: `/user/credits`,
            rel: 'noopener',
          }}
        >
          {hasLocizeTranslation(
            t,
            REFERRAL_LOCIZE.REFERRAL_CHECK_BALANCE.key,
            REFERRAL_LOCIZE.REFERRAL_CHECK_BALANCE.text,
          )}
        </Button>
      </div>
    </div>
  )
}

ReferralCashBack.propTypes = {
  t: PropTypes.func.isRequired,
}

export default withI18next()(ReferralCashBack)
